//export const Base_URL = 'http://127.0.0.1:8000'
//export const API_URL = 'http://127.0.0.1:8000/api/'
// Images still live on production until local public/uploads is populated.
//export const ASSET_URL = 'https://weldforce.net/weldforce'
export const Base_URL = 'https://weldforce.net'
export const API_URL = 'https://weldforce.net/test/api/'
export const ASSET_URL = 'https://weldforce.net/test'
